<template>
  <boxDropDown title="Alterar fuso do turno">
    <template>

      <div class="form-group col-xs-12 col-sm-12 col-md-12">
        <label for="workshiftIdTzInput">ID do turno</label>
        <input type="text" class="form-control" placeholder="Insira o ID do turno" id="workshiftIdTzInput"
          v-model="workshiftId" @blur="validateWorkshiftId()">
      </div>

      <div class="form-group col-xs-12 col-sm-12 col-md-12">
        <label>Fuso horário</label>
        <select v-model="timezone" class="form-control" :disabled="loadingTimezones">
          <option value="">{{ loadingTimezones ? 'Carregando...' : 'Selecione o fuso horário' }}</option>
          <option v-for="(label, key) in timezones" :key="key" :value="key">{{ label }}</option>
        </select>
      </div>

      <div v-if="errorMessage" class="text-danger col-xs-12 col-sm-12 col-md-12 text-center spacing-bottom" role="alert">
        {{ errorMessage }}
      </div>

      <div class="form-group col-md-12 full-width text-center">
        <button class="btn btn-primary" :disabled="isDisabled()" @click="handleSubmit()">
          <span v-if="!loading">Alterar fuso</span>
          <span v-else class="loading-btn">
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </span>
        </button>
      </div>

    </template>
  </boxDropDown>
</template>

<script>
import {
  WORKSHIFT_TIMEZONE_UPDATE,
  GET_TIMEZONE_LIST,
} from "../../../../../urlConfig";
import { REQUEST_SERVICE } from "../../../../../requestConfig";
import { ALERT_SERVICE } from "../../../../../msgAlertService";
import boxDropDown from "../../../components/layouts/boxDropDown.vue";

export default {
  name: "workshift-timezone-tool",
  components: { boxDropDown },
  data() {
    return {
      workshiftId: '',
      timezone: '',
      timezones: {},
      errorMessage: '',
      loading: false,
      loadingTimezones: false,
    };
  },
  created() {
    this.fetchTimezones();
  },
  methods: {
    fetchTimezones() {
      this.loadingTimezones = true;
      REQUEST_SERVICE.get(GET_TIMEZONE_LIST)
        .then((response) => {
          this.timezones = response.data;
          this.loadingTimezones = false;
        })
        .catch(() => {
          this.loadingTimezones = false;
          ALERT_SERVICE.swal("ERRO", "Não foi possível carregar os fusos horários", "error");
        });
    },
    isDisabled() {
      return this.loading || this.loadingTimezones;
    },
    validateWorkshiftId() {
      if (this.workshiftId.trim().length !== 32) {
        this.errorMessage = "O ID do turno deve conter 32 caracteres";
        return false;
      }
      this.errorMessage = '';
      return true;
    },
    validate() {
      if (!this.validateWorkshiftId()) return false;
      if (!this.timezone) {
        this.errorMessage = "Selecione um fuso horário";
        return false;
      }
      this.errorMessage = '';
      return true;
    },
    handleSubmit() {
      if (!this.validate()) return;

      this.loading = true;
      const url = `${WORKSHIFT_TIMEZONE_UPDATE}?workshiftId=${this.workshiftId.trim()}&timezone=${encodeURIComponent(this.timezone)}`;

      REQUEST_SERVICE.get(url)
        .then(() => {
          this.loading = false;
          ALERT_SERVICE.swal("Sucesso", "Fuso horário do turno alterado com sucesso!", "success");
          this.clearFields();
        })
        .catch((reason) => {
          this.loading = false;
          const erros = reason && reason.response && reason.response.data && reason.response.data.erros;
          if (erros && erros.length > 0) {
            ALERT_SERVICE.swal("ERRO", erros[0].value, "error");
          } else {
            ALERT_SERVICE.swal("ERRO", "Entre em contato com a equipe de desenvolvimento", "error");
          }
        });
    },
    clearFields() {
      this.workshiftId = '';
      this.timezone = '';
      this.errorMessage = '';
    },
  },
};
</script>

<style lang="scss">

* {
  font-family: "Montserrat", sans-serif !important;
}

.full-width {
  width: 100% !important;
}

.spacing-bottom {
  margin-bottom: 8px;
}

ul {
  list-style: none;
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/support/supportItems/workShiftTimeZoneTool.vue